import { P360NotInScopeWidgetPlaceholder } from 'legacy/lut/components/widgets/public/partner360/components/p360NotInScopeWidgetPlaceholder/P360NotInScopeWidgetPlaceholder'
import { P360Card } from 'legacy/lut/components/widgets/public/partner360/p360Card'
import { P360WidgetPlaceholder } from 'legacy/lut/components/widgets/public/partner360/P360WidgetPlaceholder'
import { selectGlobalPartnerData, selectGPLoadingStatus } from 'legacy/lut/features/globalPartner'
import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import React, { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { selectCurrentSitePageId } from 'core-components/sitebuilder/store/selectors/selectCurrentSitePageId'
import MeasureController from 'core/analytics/MeasureController'
import { withPartner360Checks } from 'partner360/hoc/withPartner360Checks'

import { NotPartnerAccountPlaceholder } from './components/notPartnerAccountPlaceholder/NotPartnerAccountPlaceholder'
import { FYearSelector } from './fYearSelector'
import { ProgramTypeButtons } from './programTypeButtons'

import styles from './P360PartnerSettings.module.scss'

interface IP360PartnerSettings {
  widgetParams: IObjectAny
  flexWidth: FlexDirectionBreak
  metrics: MeasureController
  pid: string
}

export const PartnerSettings: FC<IP360PartnerSettings> = (props) => {
  const currentSitePageId = useSelector(selectCurrentSitePageId)
  const isGlobalPage = useMemo(() => {
    return currentSitePageId === 'jbl-hpscoutso-global'
  }, [currentSitePageId])
  const globalData = useSelector(selectGlobalPartnerData)
  const gpLoadingStatus = useSelector(selectGPLoadingStatus)

  const eltGroupUIID = useMemo(() => {
    if (gpLoadingStatus === RequestStatus.PENDING) {
      return null
    }
    if (!isGlobalPage) {
      return null
    }
    return globalData?.eLTGroupUID
  }, [globalData?.eLTGroupUID, gpLoadingStatus, isGlobalPage])

  return (
    <P360Card className={styles.p360card}>
      <div className={styles.root}>
        <FYearSelector className={styles.yearsWrapper} {...props} />
        <div className={styles.divider} />
        <ProgramTypeButtons
          {...props}
          className={styles.programTypesWrapper}
          eltGroupUIID={eltGroupUIID}
        />
      </div>
    </P360Card>
  )
}

export const P360PartnerSettings = withPartner360Checks<IP360PartnerSettings>(
  (props) => {
    const { isPartnerUser } = useUserRoles()
    const currentSitePageId = useSelector(selectCurrentSitePageId)

    const isP360Page = useMemo(() => {
      return currentSitePageId === 'p360'
    }, [currentSitePageId])

    if (!isPartnerUser && isP360Page) {
      return <NotPartnerAccountPlaceholder />
    }

    return <PartnerSettings {...props} />
  },
  {
    accessOverlayPlaceholder: <P360WidgetPlaceholder />,
    scopeOverlayPlaceholder: <P360NotInScopeWidgetPlaceholder />,
  }
)

P360PartnerSettings.displayName = 'Protected(P360PartnerSettings)'
